import { IAuthUser, TUserData } from '../../types/userData';

export function isAuthenticatedUser(userForCheck: TUserData): userForCheck is IAuthUser {
  return 'email' in userForCheck;
}
